export const theme = {
    colors: {
        primary: "#FE6D05", // User Preferred Orange
        secondary: "#0f172a", // Slate 900 - Strong dark secondary for contrast
        accent: "#f59e0b", // Amber 500 - Warm accent for highlights (buttons/badges)
        success: "#10b981", // Emerald 500
        danger: "#ef4444", // Red 500
        warning: "#f59e0b", // Amber 500
        info: "#3b82f6", // Blue 500

        // Neutrals
        dark: "#0f172a", // Slate 900
        darkBlue: "#1e293b", // Slate 800
        gray: "#64748b", // Slate 500
        lightGray: "#e2e8f0", // Slate 200
        light: "#f8fafc", // Slate 50 - Main background
        white: "#ffffff",
    },
    gradients: {
        // Smooth, professional gradients
        main: "linear-gradient(135deg, #FE6D05 0%, #ea580c 100%)", // Orange gradient
        accent: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)", // Amber gradient
        dark: "linear-gradient(180deg, #0f172a 0%, #1e293b 100%)", // Sidebar background
        header: "linear-gradient(90deg, #1e293b 0%, #0f172a 100%)", // Topbar/Modal header
        light: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", // Subtle background
        card: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)", // Card background

        // Transparent overlays for active states
        activeItem: "linear-gradient(90deg, rgba(254, 109, 5, 0.1), rgba(254, 109, 5, 0.05))",
    },
    borders: {
        light: "1px solid #e2e8f0", // Subtle border
        default: "1px solid #cbd5e1", // Medium border
        dark: "1px solid #334155", // Dark mode border
    },
    shadows: {
        default: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)", // Small
        card: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.05)", // Medium
        hover: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)", // Large
        glow: "0 0 15px rgba(254, 109, 5, 0.3)", // Primary glow
    },
};
